import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Triangle move flag.
 *
 * @remarks
 * Marks a move as a triangle move (ride before AND after, both charged in full
 * to customer). Set via admin UI toggle based on customer-level allow_triangle_moves
 * permission.
 *
 * When true:
 * - Move class is set to 'base'
 * - Rate class override is set to 1
 * - Both rides are charged to customer at full rate
 *
 * Interacts with customer permission: allow_triangle_moves must be true for
 * the toggle to be available.
 */
export const schema = z.boolean().optional();

export type TriangleMove = z.infer<typeof schema>;

export const definition = define({
  key: 'triangle_move',
  schema,
  label: 'Triangle Move',
  description:
    'Marks move as triangle (ride before AND after charged to customer). Set via admin UI when customer has allow_triangle_moves permission.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
